<template>
    <div class="position-relative top-notification-wrap">
        <b-dropdown right @show="onShow" @hide="onHide">
        <template #button-content>
            <i class="bell-icon">
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.775 21.359V21.1885H20.4186C21.0987 21.1885 21.65 20.6372 21.65 19.9571C21.65 19.6326 21.5219 19.3212 21.2936 19.0907L20.1263 17.9119C20.0614 17.8463 20.025 17.7578 20.025 17.6656V13.9744C20.025 11.4523 18.7852 9.18985 16.4774 8.34023C16.4362 8.32505 16.4054 8.30017 16.3876 8.27677C16.3712 8.25521 16.3687 8.23998 16.3687 8.23077C16.3687 7.19679 15.5394 6.35 14.5 6.35C13.4606 6.35 12.6312 7.19679 12.6312 8.23077C12.6312 8.23987 12.6289 8.25496 12.6126 8.27632C12.5948 8.29953 12.5643 8.3242 12.5233 8.3392C10.2078 9.18737 8.975 11.4451 8.975 13.9744V17.6656C8.975 17.7578 8.93859 17.8463 8.8737 17.9119L7.7064 19.0907C7.47808 19.3212 7.35 19.6326 7.35 19.9571C7.35 20.6372 7.9013 21.1885 8.58137 21.1885H12.225V21.359C12.225 22.6124 13.231 23.65 14.5 23.65C15.7587 23.65 16.775 22.6145 16.775 21.359Z" stroke="#C2CAD8" stroke-width="1.3"/>
                </svg>
                <span :class="countUnreadableNotifications > 0 ? 'new' : ''">{{ countUnreadableNotifications }}</span>
            </i>
        </template>
        <div class="info-box" role="menu">
            <div class="top-info">
                <div class="left">
                    <h4>Notifications</h4>
                </div>
                <div class="right">
                    <icon v-if="isRunningActionSetAllRead" name="faSpinner" size="19" color="currentColor" pulse />
                    <button class="btn" :disabled="!countUnreadableNotifications" @click="setAllRead">Mark all as read</button>
                </div>
            </div>

            <p class="text-center empty-text" v-if="items.length === 0">You have no notifications</p>

            <div v-else class="wrapper">
                <div class="item" v-for="item in items" :key="item.id" :class="item.read_at ? 'read' : 'unread'">
                    <div class="item-info">
                        <router-link class="title"
                            v-if="mapRotes[item.data.type] && mapRotes[item.data.type].params"
                            :to="{ name:mapRotes[item.data.type].to, params:mapRotes[item.data.type].params }">
                            <strong>{{ item.data.type }}</strong>
                        </router-link>
                        <router-link class="title"
                            v-else-if="mapRotes[item.data.type] && !mapRotes[item.data.type].params"
                            :to="{ name:mapRotes[item.data.type].to }">
                            <strong>{{ item.data.type }}</strong>
                        </router-link>
                        <p v-else><strong>{{ item.data.type }}</strong></p>

                        <div class="date">{{ formatDate(item.created_at) }}</div>
                        <div class="sub-title">{{ item.data.type + ' ' + extraTitle}}</div>
                        <ul class="msg-list">
                            <li v-for="msg in item.data.messages" :key="msg.title + item.id">{{msg.title}}: {{msg.count}}</li>
                        </ul>
                    </div>
                    <div class="action">
                        <div class="inner" v-if="!item.read_at">
                            <icon v-if="isRunningAction[item.id]" name="faSpinner" size="19" color="currentColor" pulse class="spinner-icon" />
                            <a href="javascript:void(0)" class="btn" @click="setRead(item)">
                                <icon name="faCircle" size="14" color="inherit" class="icon-blue" title="Mark as read" />
                            </a>
                        </div>
                        <div class="inner" v-else>
                            <icon v-if="isRunningAction[item.id]" name="faSpinner" size="19" color="currentColor" pulse class="spinner-icon" />
                            <a href="javascript:void(0)" class="btn" @click="setUnRead(item)">
                                <icon name="faCircle" size="14" color="inherit" class="icon-grey" title="Mark as unread" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </b-dropdown>
    </div>
</template>

<script>

import NotificationService from "../lib/services/NotificationService";
import formattedDate from "../mixins/formattedDate";
import notificationService from '@/js/services/notification-service';

export default {
    name: "Notification",
    components: {
    },
    props: {
    },
    mixins: [formattedDate],
    data() {
        return {
            isRunningActionSetAllRead: false,
            isRunningAction: {},
            interval: 60000,
            service: new NotificationService(),
            extraTitle: 'list was updated',

            items: [],
            mapRotes: {
                "Adult sites": {
                    to: "dsp-lists-trade",
                    params: {
                        name: "adultsite"
                    }
                },
                "Blocked sites": {
                    to: "trade-options-blocked-site",
                    params: {
                        side: "global",
                        name: "site",
                        type: "blocked",
                        id: 0
                    }
                },
                "Blocked bundles": {
                    to: "trade-options-blocked-bundle",
                    params: {
                        side: "global",
                        name: "bundle",
                        type: "blocked",
                        id: 0
                    }
                },

            },

        }
    },
    mounted() {
        this.getNotifications();
    },

    watch: {

    },
    computed: {
        countUnreadableNotifications() {
            return this.items.filter(notification => notification.read_at === null).length;
        }
    },
    methods: {
        subscribeToNotifications() {
            this.$root.userPromise.then(() => {
                window.Echo.private("App.Models.User." + this.$root.user.id)
                    .notification((notification) => {
                        if (!this.items.find(i => i.id === notification.id)) {
                            this.items.unshift(notification);
                        }
                    });
            });
        },
        onShow() {
            let wrap = document.getElementsByClassName('over-wrap')[0];
            wrap.classList.add('for-mobile');
        },
        onHide() {
            let wrap = document.getElementsByClassName('over-wrap')[0];
            wrap.classList.remove('for-mobile');
        },
        async getNotifications() {
            this.items = await this.service.get();
            this.subscribeToNotifications();

            return this.items || [];
        },
        async setRead(item) {
            this.$set(this.isRunningAction, item.id, true);
            try {
                const data = await this.service.setRead(item.id);
                item.read_at = data.read_at

            } catch (e) {
                notificationService.error('Error mark as read notification.')
            } finally {
                this.$set(this.isRunningAction, item.id, false);
            }
        },
        async setUnRead(item) {
            this.$set(this.isRunningAction, item.id, true);
            try {
                const data = await this.service.setUnRead(item.id);
                item.read_at = data.read_at

            } catch (e) {
                notificationService.error('Error mark as unread notification.')
            } finally {
                this.$set(this.isRunningAction, item.id, false);
            }
        },
        async setAllRead() {
            this.isRunningActionSetAllRead = true;
            try {
                await this.service.setAllRead();
                await this.getNotifications();
            } catch (e) {
                notificationService.error('Error mark as all read notifications.')
            } finally {
                this.isRunningActionSetAllRead = false;
            }
        },

    }
}
</script>

<style lang="scss" scoped>



.icon-grey{
    color: #c1d6e7;
}
.icon-blue{
    color: #5C9BD1;
}

 .top-notification-wrap {

     width: 50px;
     height: 75px;
    float: right;
     border: solid #F5F5F6;
     border-width: 0 1px;
     display: flex;
     justify-content: center;


     ::v-deep(.dropdown) {
         display: block;
         width: 100%;

         &.show {
             .dropdown-toggle {
                 background-color: #F5FAFF;
             }
         }
         .dropdown-menu {
           margin-top: -1px;
           @media (max-width: 992px) {
             right: 0 !important;
             left: auto !important;
             transform: none !important;
             top: 75px !important;
           }
             &:before, &:after {
                 display: none !important;
             }
         }
     }
     ::v-deep(.dropdown-toggle) {
         display: flex;
         width: 100%;
         height: 100%;
         padding: 0 !important;
         position: relative;
         background-color: transparent;
         &:hover {
             background-color: #F5FAFF;
         }
         .bell-icon {
             position: absolute;
             width: 100%;
             height: 100%;
             top: 0;
             left: 0;
             display: flex;
             justify-content: center;
             align-items: center;
             float: none;
             margin-top: 0 !important;
             span {
                 position: absolute;
                 right: 10px;
                 bottom: 20px;
                 width: 12px;
                 height: 12px;
                 border-radius: 50% !important;
                 background: #637381;
                 color: #fff;
                 line-height: 12px;
                 text-align: center;
                 font-size: 8px;
                 display: block;
                 font-style: normal;
                 &.new {
                     background: #EB5757;
                 }
             }
         }
     }
     .info-box {
         margin-top: 0;
         padding: 0;
         background-color: #fff!important;
         display: block;
         width: 380px !important;
         min-width: auto;
         min-height: 200px!important;
         max-height: 515px;
         overflow: auto;
         box-shadow: 0px 1px 5px 0px #0000001A;
         position: relative;
         .empty-text {
             position: absolute;
             top: 50%;
             left: 50%;
             transform: translate(-50%, -50%);
         }
       @media (max-width: 480px) {
         width: 280px !important;
       }
        .top-info {
            padding: 20px 20px 10px 20px;
            display: flex;
            width: 100%;
            .left {
                width: 50%;
            }
            .right {
                width: 50%;
                text-align: right;
            }
            h4 {
                font-size: 18px;
                color: #1C2D3F;
                line-height: 20px;
                margin: 0;

            }
            .btn {
                background: none;
                padding: 0;
                color: #457AB2;
                font-size: 13px;
                &:hover {
                    background: none;
                }
            }
        }
         .wrapper {
             .item {
                 padding: 15px 20px;
                 transition: all 400ms;
                 position: relative;
                 border-top: 1px solid #ECEDF1;
                 &:first-child {
                     border: none;
                 }
                 &.unread {
                     background-color: #F5FAFF;
                     .spinner-icon {
                         background-color: #F5FAFF;
                     }
                 }
                 &.read {
                     background-color: #fff;
                     .spinner-icon {
                         background-color: #fff;
                     }
                 }
                 .item-info {
                     .title {
                         display: block;
                         font-size: 14px;
                         line-height: 21px;
                         color: #111827;
                         font-weight: 700;
                         padding-bottom: 4px;
                         padding-right: 23px;
                     }
                     .date {
                         font-size: 10px;
                         color: #374151;
                         font-weight: 400;
                         line-height: 20px;
                     }
                     .sub-title {
                         font-size: 14px;
                     }
                     .msg-list {
                         padding-top: 0;
                         margin-top: 0;
                         padding-left: 20px;
                         list-style-type: disc;
                         li {
                             font-size: 14px;
                         }
                     }
                 }
                 .action {
                     position: absolute;
                     top: 8px;
                     right: 8px;
                     .spinner-icon {
                         position: absolute;
                         top: 9px;
                         right: 3px;
                         z-index: 2;
                     }
                     .btn {
                         width: 30px;
                         height: 30px;
                         border-radius: 50% !important;
                         padding: 0;
                         display: flex;
                         justify-content: center;
                         align-items: center;
                         background-color: transparent;
                         transition: 0.4s all;
                         position: relative;
                         z-index: 0;
                         &:hover {
                             background-color: #dbe4f0;
                         }
                     }
                 }
             }
         }
     }
 }

</style>
